import {
    Bookmark,
    Columns2,
    Download,
    Heart,
    Image as ImageIcon,
    Images,
    Layers,
    LucideIcon,
    Menu,
    Plus,
    Share2,
    ShoppingBag,
    ShoppingCart,
    Sparkles,
    Tag,
    Upload,
} from 'lucide-react';
import { ProductInfoField, RoomWidgetId, RoomZone } from './layout.schema';

/** How each widget is named and drawn in the editor. Labels are i18n keys. */
export const WIDGET_META: Record<RoomWidgetId, { icon: LucideIcon; labelKey: string; descKey: string; isButton: boolean }> = {
    logo: { icon: ImageIcon, labelKey: 'VISUALIZER_LAYOUT.WIDGET.LOGO', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.LOGO', isButton: false },
    changeRoom: { icon: Images, labelKey: 'VISUALIZER_LAYOUT.WIDGET.CHANGE_ROOM', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.CHANGE_ROOM', isButton: true },
    appliedProducts: { icon: Layers, labelKey: 'VISUALIZER_LAYOUT.WIDGET.APPLIED_PRODUCTS', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.APPLIED_PRODUCTS', isButton: false },
    productInfo: { icon: Tag, labelKey: 'VISUALIZER_LAYOUT.WIDGET.PRODUCT_INFO', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.PRODUCT_INFO', isButton: false },
    share: { icon: Share2, labelKey: 'VISUALIZER_LAYOUT.WIDGET.SHARE', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.SHARE', isButton: true },
    download: { icon: Download, labelKey: 'VISUALIZER_LAYOUT.WIDGET.DOWNLOAD', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.DOWNLOAD', isButton: true },
    compare: { icon: Columns2, labelKey: 'VISUALIZER_LAYOUT.WIDGET.COMPARE', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.COMPARE', isButton: true },
    upload: { icon: Upload, labelKey: 'VISUALIZER_LAYOUT.WIDGET.UPLOAD', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.UPLOAD', isButton: true },
    order: { icon: ShoppingCart, labelKey: 'VISUALIZER_LAYOUT.WIDGET.ORDER', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.ORDER', isButton: true },
    cart: { icon: ShoppingBag, labelKey: 'VISUALIZER_LAYOUT.WIDGET.CART', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.CART', isButton: true },
    favorites: { icon: Heart, labelKey: 'VISUALIZER_LAYOUT.WIDGET.FAVORITES', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.FAVORITES', isButton: true },
    addProduct: { icon: Plus, labelKey: 'VISUALIZER_LAYOUT.WIDGET.ADD_PRODUCT', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.ADD_PRODUCT', isButton: true },
    menu: { icon: Menu, labelKey: 'VISUALIZER_LAYOUT.WIDGET.MENU', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.MENU', isButton: true },
    assistant: { icon: Sparkles, labelKey: 'VISUALIZER_LAYOUT.WIDGET.ASSISTANT', descKey: 'VISUALIZER_LAYOUT.WIDGET_DESC.ASSISTANT', isButton: true },
    saveRoom: { icon: Bookmark, labelKey: 'SAVED_ROOMS.LAYOUT.WIDGET', descKey: 'SAVED_ROOMS.LAYOUT.WIDGET_DESC', isButton: true },
};

export const ZONE_LABEL_KEYS: Record<RoomZone, string> = {
    'topbar.start': 'VISUALIZER_LAYOUT.ZONE.TOPBAR_START',
    'topbar.center': 'VISUALIZER_LAYOUT.ZONE.TOPBAR_CENTER',
    'topbar.end': 'VISUALIZER_LAYOUT.ZONE.TOPBAR_END',
    'panel.header': 'VISUALIZER_LAYOUT.ZONE.PANEL_HEADER',
    'canvas.topLeft': 'VISUALIZER_LAYOUT.ZONE.CANVAS_TOP_LEFT',
    'canvas.topCenter': 'VISUALIZER_LAYOUT.ZONE.CANVAS_TOP_CENTER',
    'canvas.topRight': 'VISUALIZER_LAYOUT.ZONE.CANVAS_TOP_RIGHT',
    'canvas.bottomLeft': 'VISUALIZER_LAYOUT.ZONE.CANVAS_BOTTOM_LEFT',
    'canvas.bottomCenter': 'VISUALIZER_LAYOUT.ZONE.CANVAS_BOTTOM_CENTER',
    'canvas.bottomRight': 'VISUALIZER_LAYOUT.ZONE.CANVAS_BOTTOM_RIGHT',
};

export const FIELD_LABEL_KEYS: Record<ProductInfoField, string> = {
    brand: 'VISUALIZER_LAYOUT.FIELD.BRAND',
    name: 'VISUALIZER_LAYOUT.FIELD.NAME',
    color: 'VISUALIZER_LAYOUT.FIELD.COLOR',
    size: 'VISUALIZER_LAYOUT.FIELD.SIZE',
    pattern: 'VISUALIZER_LAYOUT.FIELD.PATTERN',
    sku: 'VISUALIZER_LAYOUT.FIELD.SKU',
    type: 'VISUALIZER_LAYOUT.FIELD.TYPE',
    collection: 'VISUALIZER_LAYOUT.FIELD.COLLECTION',
};

export const PRESET_KEYS: Record<string, { nameKey: string; descKey: string }> = {
    classic: { nameKey: 'VISUALIZER_LAYOUT.PRESET.CLASSIC', descKey: 'VISUALIZER_LAYOUT.PRESET.CLASSIC_DESC' },
    studio: { nameKey: 'VISUALIZER_LAYOUT.PRESET.STUDIO', descKey: 'VISUALIZER_LAYOUT.PRESET.STUDIO_DESC' },
    immersive: { nameKey: 'VISUALIZER_LAYOUT.PRESET.IMMERSIVE', descKey: 'VISUALIZER_LAYOUT.PRESET.IMMERSIVE_DESC' },
    minimal: { nameKey: 'VISUALIZER_LAYOUT.PRESET.MINIMAL', descKey: 'VISUALIZER_LAYOUT.PRESET.MINIMAL_DESC' },
    showroom: { nameKey: 'VISUALIZER_LAYOUT.PRESET.SHOWROOM', descKey: 'VISUALIZER_LAYOUT.PRESET.SHOWROOM_DESC' },
};
